import React from 'react';
import { Card, TitleCard, HeaderCard, ContentCard, Button } from '@weezevent/nacre';
import css from '../manual-modal.module.css';
import { useTranslation } from 'react-i18next';
import SummaryItem from './SummaryItem';

export default function ModalSummary({
    form,
    categories,
    selectedZone,
    previousZone,
    onChange,
    onChangeAllForm,
    handleClose,
    availability,
    sync,
    currentInventory,
    inventories,
    unbookBooking,
    onAddAttendee,
    timer
}) {
    const { t } = useTranslation();

    const handleContinue = React.useCallback(() => {
        handleClose();
    }, [handleClose]);

    let counter = React.useMemo(() => {
        return form.attendees.length;
    }, [form]);

    return (
        <>
            <Card className={css['swap-seat-list']}>
                <div className={css['content-container']}>
                    <HeaderCard separator={false}>
                        <TitleCard className={css['title']} title={t('attendees.addAttendees.withSeats.modalTitle')} />
                        {timer}
                    </HeaderCard>
                    <ContentCard className={css['content']}>
                        {inventories.map(inventory => {
                            let attendees = form.attendees.filter(attendee => attendee.booking_uuid && attendee.booking_uuid.inventory === inventory.pk);

                            return (
                                <SummaryItem
                                    key={inventory.uuid}
                                    form={form}
                                    onAddAttendee={onAddAttendee}
                                    onChange={onChange}
                                    onChangeAllForm={onChangeAllForm}
                                    inventory={inventory}
                                    attendees={attendees}
                                    categories={categories}
                                    selectedZone={selectedZone}
                                    previousZone={previousZone}
                                    currentInventory={currentInventory}
                                    availability={availability}
                                    sync={sync}
                                    unbookBooking={unbookBooking}
                                />
                            );
                        })}
                    </ContentCard>
                </div>
                <ContentCard className={css['footer']}>
                    <div className={css['modal-attendees-count']}>
                        {t('attendees.addAttendees.withSeats.modalValid')} <span>{counter}</span>
                    </div>
                    <Button fluid primary disabled={!form.attendees.length} onClick={handleContinue} label={t(`ticket.common.action.save`)} />
                </ContentCard>
            </Card>
        </>
    );
}
